import { STATIC_ASSETS_URL } from "common/context/constants"

import "../style.scss"

const NotificationsNoData = () => {
  return (
    <div className='d-flex justify-content-center align-items-center h-100'>
      <img
        className='mb-5 h-25 w-25'
        src={`${STATIC_ASSETS_URL}/Imagenes/Ilustraciones/sin_notificaciones.svg`}
        alt='Bicolor.svg'
      />
    </div>
  )
}

export default NotificationsNoData
